<template>
  <div class="CarNetwork">
    <div class="CarNetwork-header">
      <el-container>
      <el-header >
        <Head :active="1"/>
        <szhimg
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none"
        />
        
      </el-header>
    </el-container>
    </div>
    <div class="smartproductsimg">
      <img src="../../../public/img/internet/Frame6.png" alt="">
    </div>
    <div class="bigback" >
      <div class="platform-advantages">
        <h2 class="section-title">产品特点</h2>
        <div class="advantages-container">
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame11.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>全球频段</h3>
              <p>
                支持全球频段,无缝切换, 网络兼容性强
              </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame12.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>工业级设计标准</h3>
              <p>
                采用工业级通信处理器和无线模块,确保设备在恶劣环境下稳定            </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame13.png" alt="" />
            </div>
            <div class="icon-wrapperss">
            <h3>高可靠性设计</h3>
            <p>
                采用双MCU结构的硬件平台,运算能力强,扩展性强,可靠性高
              </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame14.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>数据安全</h3>
              <p>
                支持SSL/TLS加密传输,双向证书校验,保障数据安全
            </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame15.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>远程运维</h3>
              <p>
                支持云平台运维和APP运维
              </p>  
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame16.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>大屏展示</h3>
              <p>
                项目大数据展示,集中管理和监控
              </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame17.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>故障预警</h3>
              <p>
                故障信息及时推送,预防性维护提前预知设备故障
              </p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon-wrapper">
              <!-- Icon placeholder -->
              <img src="../../../public/img/internet/Frame18.png" alt="" />
            </div>
            <div class="icon-wrapperss">
              <h3>大数据分析</h3>
              <p>
                海量数据分析,项目状态心中有数  
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div>
        <div class="product-selection">
          <h2 class="section-title">产品选型</h2>
          
          <!-- 产品类型选择 -->
          <div class="filter-section">
            <div class="filter-rows">
              <div class="filter-optionss">
                <span class="bigbtn" :class="['filter-option', activeType === '全部' ? 'active' : '']" @click="filterByType('全部')">全部</span>
                <span class="bigbtn" :class="['filter-option', activeType === 'DTU' ? 'active' : '']" @click="filterByType('DTU')">DTU</span>
                <span class="bigbtn" :class="['filter-option', activeType === '智能网关' ? 'active' : '']" @click="filterByType('智能网关')">智能网关</span>
              </div>
            </div>

            <!-- 网络制式 -->
            <div class="filter-row">
              <span class="filter-label">网络制式</span>
              <div class="filter-options">
                <span :class="['filter-option', activeNetwork === '全部' ? 'active' : '']" @click="filterByNetwork('全部')">全部</span>
                <span :class="['filter-option', activeNetwork === '4G Cat.1' ? 'active' : '']" @click="filterByNetwork('4G Cat.1')">4G Cat.1</span>
                <span :class="['filter-option', activeNetwork === '4G Cat.4' ? 'active' : '']" @click="filterByNetwork('4G Cat.4')">4G Cat.4</span>
                <span :class="['filter-option', activeNetwork === 'WIFI' ? 'active' : '']" @click="filterByNetwork('WIFI')">WIFI</span>
              </div>
            </div>

            <!-- 串口类型 -->
            <div class="filter-row">
              <span class="filter-label">串口类型</span>
              <div class="filter-options">
                <span :class="['filter-option', activeSerial === '全部' ? 'active' : '']" @click="filterBySerial('全部')">全部</span>
                <span :class="['filter-option', activeSerial === 'RS485' ? 'active' : '']" @click="filterBySerial('RS485')">RS485</span>
                <span :class="['filter-option', activeSerial === 'RS232' ? 'active' : '']" @click="filterBySerial('RS232')">RS232</span>
                <span :class="['filter-option', activeSerial === 'RS485/RS232' ? 'active' : '']" @click="filterBySerial('RS485/RS232')">RS485/RS232</span>
                <span :class="['filter-option', activeSerial === 'TTL' ? 'active' : '']" @click="filterBySerial('TTL')">TTL</span>
              </div>
            </div>

            <!-- 网口数量 -->
            <div class="filter-row">
              <span class="filter-label">网口数量</span>
              <div class="filter-options">
                <span :class="['filter-option', activePorts === '全部' ? 'active' : '']" @click="filterByPorts('全部')">全部</span>
                <span :class="['filter-option', activePorts === '0' ? 'active' : '']" @click="filterByPorts('0')">0</span>
                <span :class="['filter-option', activePorts === '1' ? 'active' : '']" @click="filterByPorts('1')">1</span>
                <span :class="['filter-option', activePorts === '2' ? 'active' : '']" @click="filterByPorts('2')">2</span>
                <span :class="['filter-option', activePorts === '4' ? 'active' : '']" @click="filterByPorts('4')">4</span>
              </div>
            </div>

            <!-- 安装方式 -->
            <div class="filter-row">
              <span class="filter-label">安装方式</span>
              <div class="filter-options">
                <span :class="['filter-option', activeInstall === '全部' ? 'active' : '']" @click="filterByInstall('全部')">全部</span>
                <span :class="['filter-option', activeInstall === '壁挂' ? 'active' : '']" @click="filterByInstall('壁挂')">壁挂</span>
                <span :class="['filter-option', activeInstall === '导轨式' ? 'active' : '']" @click="filterByInstall('导轨式')">导轨式</span>
                <span :class="['filter-option', activeInstall === '挂耳式' ? 'active' : '']" @click="filterByInstall('挂耳式')">挂耳式</span>
                <span :class="['filter-option', activeInstall === '抱杆式' ? 'active' : '']" @click="filterByInstall('抱杆式')">抱杆式</span>
                <span :class="['filter-option', activeInstall === '其他' ? 'active' : '']" @click="filterByInstall('其他')">其他</span>
              </div>
            </div>

            <!-- 使用地区 -->
            <div class="filter-row">
              <span class="filter-label">使用地区</span>
              <div class="filter-options">
                <span :class="['filter-option', activeRegion === '全部' ? 'active' : '']" @click="filterByRegion('全部')">全部</span>
                <span :class="['filter-option', activeRegion === '中国' ? 'active' : '']" @click="filterByRegion('中国')">中国</span>
                <span :class="['filter-option', activeRegion === '印度/东南亚' ? 'active' : '']" @click="filterByRegion('印度/东南亚')">印度/东南亚</span>
                <span :class="['filter-option', activeRegion === 'EMEA/南美/北美/澳洲' ? 'active' : '']" @click="filterByRegion('EMEA/南美/北美/澳洲')">EMEA/南美/北美/澳洲</span>
                <span :class="['filter-option', activeRegion === '拉丁美洲' ? 'active' : '']" @click="filterByRegion('拉丁美洲')">拉丁美洲</span>
                <span :class="['filter-option', activeRegion === '其他地区' ? 'active' : '']" @click="filterByRegion('其他地区')">其他地区</span>
              </div>
            </div>
          </div>

          <!-- 产品列表 -->
          <div class="product-list">
            <div class="product-table">
              <div class="table-header">
                <div class="header-cell">产品型号</div>
                <div class="header-cell">产品尺寸（mm）</div>
                <div class="header-cell">串口数量/类型</div>
                <div class="header-cell">网络协议</div>
                <div class="header-cell">功能特点</div>
                <div class="header-cell">超值服务</div>
              </div>
              <div 
                v-for="(product, index) in filteredProducts" 
                :key="index"
                class="table-row"
                @click="goToProductDetail(product)"
                @mouseover="hoveredProduct = product.id"
                @mouseleave="hoveredProduct = null"
                :class="{ 'hovered': hoveredProduct === product.id }"
              >
                <div class="cell product-info">
                  <img :src="product.image" :alt="product.model" />
                  <span>{{ product.model }}</span>
                </div>
                <div class="cell">{{ product.dimensions }}</div>
                <div class="cell">{{ product.ports }}</div>
                <div class="cell">{{ product.protocol }}</div>
                <div class="cell">{{ product.features }}</div>
                <div class="cell" style="text-align: left;">{{ product.services }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="foter">
        <v-footer></v-footer>
      </div>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import szhimg from "../quanqiulianjie.vue";
import planDialog from "@components/planDialog.vue";
import vFooter from "@/components/footer2.vue";
export default {
  name: "smartproducts",
  components: {
    Head,
    szhimg,
    planDialog,
    vFooter,
  },
  data() {
    return {
      isShow: false,
      bannerData: [
        {
          title: "智联产品",
          content:
            "云百以智能终端+全球流量+平台的一站式解决方案形式,实现全球一张卡,轻松连接 180+国家、400 多家海外运营商,同时为设备厂商提供硬件的实时状态监控、定位等服务,极大降低人力成本提供高效业务能力,助力企业进行自动化管理。",
          button: "获取专属方案",
          banner: "digital_bg2",
        },
      ],
      // 筛选条件
      activeType: '全部',
      activeNetwork: '全部',
      activeSerial: '全部',
      activePorts: '全部',
      activeInstall: '全部',
      activeRegion: '全部',
      hoveredProduct: null,

      // 产品数据
      products: [
        {
          id: 1,
          model: 'YBM307GA',
          image: require('../../../public/img/internet/image15.png'),
          dimensions: '74.6*22.6*18.1',
          ports: '1串口/RS485',
          protocol: '4G-Cat1',
          features: '工业设计 内置看门狗IP61防护 eSIM',
          services: '附赠国内流量及通用云平台+手机应用',
          type: 'DTU',
          network: '4G Cat.1',
          serial: 'RS485',
          portCount: '0',
          installation: '壁挂',
          region: '中国'
        },
        {
          id: 2,
          model: 'YBM708ELGA',
          image: require('../../../public/img/internet/image16.png'),
          dimensions: '74.6*22.6*18.1',
          ports: '1串口/TTL*1',
          protocol: '4G-Cat1',
          features: '工业设计 内置看门狗 三防漆 eSIM',
          services: '附赠国内流量及通用云平台+手机应用',
          type: 'DTU',
          network: '4G Cat.1',
          serial: 'TTL',
          portCount: '0',
          installation: '其他',
          region: '中国'
        },
        {
          id: 3,
          model: 'YBM307UWG',
          image: require('../../../public/img/internet/image17.png'),
          dimensions: '74.6*22.6*18.1',
          ports: '1串口/RS485',
          protocol: '4G-Cat1 IEEE 802.11',
          features: '工业设计 内置看门狗三防漆 eSIM 4G/WiFi冗余连接',
          services: '附赠国内流量及通用云平台+手机应用',
          type: '智能网关',
          network: 'WIFI',
          serial: 'RS485',
          portCount: '0',
          installation: '其他',
          region: '中国'
        },
        {
          id: 6,
          model: 'YBM800KS',
          image: require('../../../public/img/internet/image20.png'),
          dimensions: '74.6*22.6*18.1',
          ports: 'RS485/RS232/TTL 1个串口',
          protocol: '4G-Cat1',
          features: '工业设计 内置看门狗 IP40防护',
          services: '附赠国内流量及通用云平台+手机应用',
          type: 'DTU',
          network: '4G Cat.1',
          serial: 'RS485/RS232',
          portCount: '0',
          installation: '壁挂',
          region: '中国'
        },
        {
          id: 4,
          model: 'YB2000B',
          image: require('../../../public/img/internet/image18.png'),
          dimensions: '74.0*22.0*18.1',
          ports: '1串口/RS485',
          protocol: '2网口',
          features: '工业设计 内置看门狗 IP40防护',
          services: '附赠国内流量及通用云平台+手机应用',
          type: '智能网关',
          network: '4G Cat.1',
          serial: 'RS485',
          portCount: '2',
          installation: '导轨式',
          region: '中国'
        },
        {
          id: 5,
          model: 'YG312',
          image: require('../../../public/img/internet/image19.png'),
          dimensions: '74.0*22.0*18.1',
          ports: '3串口/RS485 1串口 / CAN',
          protocol: '1网口',
          features: '工业设计 内置看门狗 IP40防护',
          services: '附赠国内流量及通用云平台+手机应用',
          type: 'DTU',
          network: '4G Cat.1',
          serial: 'RS485',
          portCount: '1',
          installation: '导轨式',
          region: '中国'
        }
      ]
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter(product => {
        const typeMatch = this.activeType === '全部' || product.type === this.activeType;
        const networkMatch = this.activeNetwork === '全部' || product.network === this.activeNetwork;
        const serialMatch = this.activeSerial === '全部' || product.serial === this.activeSerial;
        const portsMatch = this.activePorts === '全部' || product.portCount === this.activePorts;
        const installMatch = this.activeInstall === '全部' || product.installation === this.activeInstall;
        const regionMatch = this.activeRegion === '全部' || product.region === this.activeRegion;

        return typeMatch && networkMatch && serialMatch && portsMatch && installMatch && regionMatch;
      });
    }
  },
  methods: {
    closeTop() {
      this.isShow = false;
    },
    filterByType(type) {
      this.activeType = type;
    },
    filterByNetwork(network) {
      this.activeNetwork = network;
    },
    filterBySerial(serial) {
      this.activeSerial = serial;
    },
    filterByPorts(ports) {
      this.activePorts = ports;
    },
    filterByInstall(install) {
      this.activeInstall = install;
    },
    filterByRegion(region) {
      this.activeRegion = region;
    },
    goToProductDetail(product) {
      this.$router.push({
        path: '/productDetail',
        query: {
          id: product.id,
          model: product.model
        }
      });
    }
  },
  mounted(){
    
  }
};
</script>

<style lang="scss" scoped>
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-header {
  height: 80px !important;
  padding: 0;
  position: relative;
}

.car-network-section {
  img {
    width: 100%;
    height: 335px;
  }
}
.car-network-sections {
  img {
    width: 100%;
    height: 869px;
  }
}
.car-network-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 60px;
  padding: 0 20px;
}

.map-side {
  flex: 1;
  position: relative;
}

.map-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-side {
  flex: 1;
  padding-top: 20px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
}

.description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
}

.platform-advantages {
  padding: 60px 0;
  max-width: 1400px;
  margin: 0 auto;
  background: #FAFAFA;
  .section-title {
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 60px;
    color: #333;
    position: relative;
    font-family: PingFang SC, PingFang SC-500;
    

    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
  }

  .advantages-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    padding: 0 20px;
  }

  .advantage-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 32px 20px;
    border-radius: 16px;
    transition: all 0.3s ease;
    cursor: pointer;
    text-align: center;
    border: 1px solid #E5E7EB;
    height: 240px;
    background: white;
    &:hover {
      border-color: #4080ff;
      box-shadow: none;
    }

    .icon-wrapper {
      width: 60px;
      height: 60px;
      margin-bottom: 16px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }

    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 16px;
      font-family: PingFang SC, PingFang SC-500;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
      color: #666;
      margin: 0;
      text-align: left;
    }
  }
}

@media (max-width: 1024px) {
  .car-network-content {
    flex-direction: column;
    gap: 30px;
  }

  .text-side {
    padding-top: 0;
  }

  .platform-advantages {
    .advantages-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 640px) {
  .platform-advantages {
    padding: 40px 0;

    .advantages-container {
      grid-template-columns: 1fr;
    }

    .section-title {
      font-size: 24px;
      margin-bottom: 40px;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
}
.icon-wrapper {
  img {
    width: 92px;
    height: 92px;
    margin-left:5px ;
  }
}
.bigimg {
  img {
    width: 100%;
    height: 935px;
  }
}
.foter {
  margin-top: 60px;
}
.CarNetwork-header{
  height: 640px;
}
.smartproductsimg{
  margin-top: 60px  ;
  img{
    width: 100%;
    height: 979px;
  object-fit: cover;

  }
}

.product-selection {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;

  .section-title {
    font-size: 40px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 35px;
    margin-top: 20px;
    color: #333;
    position: relative;
    font-family: PingFang SC, PingFang SC-500;

    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
  }

  .filter-section {
    margin-top: 60px;

    margin-bottom: 40px;
    border-bottom:  1px solid #f0f0f0;
  }

  .filter-row {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 64px;
    padding: 10px 0;
    // margin-top: 20px;
    // margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }

  .filter-label {
    width: 120px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }

  .filter-options {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .filter-option {
    padding: 6px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    transition: all 0.3s ease;
    border: 2px solid transparent;

    &:hover {
      color: #4080ff;
      background-color: #f0f5ff;
    }

    &.active {
      background: #fff;
      color: #6085FF;
      border: 2px solid #6085FF;
      border-radius: 4px;
      font-weight: 400;
      box-shadow: none;
    }
  }
}

.product-list {
  .product-table {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
  }

  .table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 2fr 2fr;
    background-color: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    padding-top: 0px;
    padding-bottom: 0px;
    
    .header-cell {
      padding-left: 34px;
      padding-right: 34px;
      padding-top: 30px;
      padding-bottom: 30px;
      font-weight: 500;
      color: #333;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .header-cell:nth-child(2){
      padding-right: 30px;
    }
    .header-cell:nth-child(3){
      padding-right: 50px;
    }
    .header-cell:nth-child(4){
      padding-right: 80px;
    }
    .header-cell:nth-child(5){
      padding-right: 80px;
    }
    .header-cell:nth-child(6){
      padding-right: 70px;
    }
    .header-cell{
      margin-left: -20px;
    }
  }

  .table-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 2fr 2fr;
    border-bottom: 1px solid #e8e8e8;
    transition: all 0.3s ease;
    cursor: pointer;
    text-align: left;
    padding-top: 16px;
    padding-bottom: 16px;
    &:last-child {
      border-bottom: none;
    }

    &:hover, &.hovered {
      background-color: #f5f7fa;

    }
  }

  .cell {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    color: #666;
    font-size: 14px;
  }

  .product-info {
    display: flex;
    flex-direction: column;
    align-items: center;  
    gap: 0px;
    justify-content: flex-start;
    padding-left: 0px;
    padding-top: 0px;
    padding-bottom: 10px;
    text-align: center;
    

    img {
      width: 80px;
      height: 67px;
      object-fit: contain;
    }

    span {
      font-weight: 500;
      color: #333;
      text-align: center;
      padding-left: 0;
    }
  }
}

@media (max-width: 1024px) {
  .product-selection {
    padding: px;

    .filter-row {
      position: relative;
      flex-direction: column;
      align-items: flex-start;
      gap: 0px;
    }

    .filter-label {
      width: 100%;
    }
  }

  .product-list {
    .table-header, .table-row {
      grid-template-columns: 1fr 1fr;
    }

    .cell {
      padding: 12px;
    }
  }
}

@media (max-width: 640px) {
  .product-selection {
    .section-title {
      font-size: 24px;
      margin-bottom: 24px;
      font-family: PingFang SC, PingFang SC-500;
    }

    .filter-options {
      gap: 8px;
    }

    .filter-option {
      padding: 4px 12px;
      font-size: 12px;
    }
  }

  .product-list {
    .table-header, .table-row {
      grid-template-columns: 1fr;
    }

    .product-info {
      padding-left: 16px;

      img {
        width: 40px;
        height: 40px;
      }

    }
  }
}
.filter-row:nth-child(2){
  margin-top: 100px;
  padding-top: 30px;
}
.filter-rows{
  position: relative;
  .filter-optionss{
    position: absolute;
    top: -50px;
    left: 455px;
    display: flex;
    gap: 20px;
    .bigbtn {
      width: 120px;
      height: 44px;
      font-size: 18px;
      margin-left: 0;
      background: #f6f7fa;
      color: #666;
      border-radius: 8px;
      border: none;
      font-weight: 400;
      box-shadow: none;
      position: relative;
      transition: color 0.2s, background 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .bigbtn.active {
      background: linear-gradient(90deg, #0056d6 0%, #1677ff 100%);
      color: #fff;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(22,119,255,0.10);
    }
    .bigbtn:hover {
      color: #1677ff !important;
      background: #f0f5ff !important;
    }
    .bigbtn.active:hover {
      color: #fff !important;
      background: linear-gradient(90deg, #0056d6 0%, #1677ff 100%) !important;
    }
  }
}
  .icon-wrapperss{
    h3{
    padding-top: 30px;
    height: 15px;
  }
  p{
    padding-top: -10px;
    font-weight: 200;
    width: 244px;
    margin: 0 auto;
    padding-left: 17px;
    text-align: left;
  }
  }
  .bigback{
    background: url('../../../public/img/internet/beijing2.png') no-repeat center center;
    background-size: 100% 100%;
    height: 915px;
  }
  .advantage-item:nth-child(5){
    // margin-top: 100px;
   p{
    text-align: center !important;
    padding: 0;
   }
  }
  .advantage-item:nth-child(6){
    // margin-top: 100px;
    p{
    text-align: center !important;
    padding: 0;

   }
  }
  .advantage-item:nth-child(8){
    // margin-top: 100px;
    p{
    text-align: center !important;
    padding: 0;

   }
  }
</style>
